import DenyUsersPage from "components/pages/DenyUsersPage";

export default function CaptureDenyTemplateAccess(props) {
    return <DenyUsersPage/>;
}